// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.global.js
// module id = 396
// module chunks = 0